/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  MintableERC20Permit,
  MintableERC20PermitInterface,
} from "../MintableERC20Permit";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DOMAIN_SEPARATOR",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MINTER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PAUSER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "burnFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "nonces",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32",
      },
    ],
    name: "permit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type MintableERC20PermitConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: MintableERC20PermitConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class MintableERC20Permit__factory extends ContractFactory {
  constructor(...args: MintableERC20PermitConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<MintableERC20Permit> {
    return super.deploy(overrides || {}) as Promise<MintableERC20Permit>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): MintableERC20Permit {
    return super.attach(address) as MintableERC20Permit;
  }
  connect(signer: Signer): MintableERC20Permit__factory {
    return super.connect(signer) as MintableERC20Permit__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MintableERC20PermitInterface {
    return new utils.Interface(_abi) as MintableERC20PermitInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MintableERC20Permit {
    return new Contract(address, _abi, signerOrProvider) as MintableERC20Permit;
  }
}
